import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, KeyRound } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { deptName, formatErr } from "../lib/constants";
import UserDialog from "../components/UserDialog";
import ChangePasswordDialog from "../components/ChangePasswordDialog";

export default function Users() {
  const { user: me } = useAuth();
  const [users, setUsers] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [dialog, setDialog] = useState({ open: false, target: null });
  const [pwOpen, setPwOpen] = useState(false);

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); api.get("/hotels").then((r) => setHotels(r.data)); }, []);

  const hotelName = (c) => hotels.find((h) => h.code === c)?.name || c;

  const remove = async (u) => {
    if (!window.confirm(`${u.name} kullanıcısı silinsin mi?`)) return;
    try { await api.delete(`/users/${u.id}`); toast.success("Kullanıcı silindi"); load(); }
    catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <h1 className="font-display text-xl font-bold text-cyan-300 tracking-widest uppercase text-glow-sm">Şef & Kullanıcı Yönetimi</h1>
        <div className="flex gap-2">
          <button data-testid="change-password-btn" onClick={() => setPwOpen(true)} className="btn-cyan px-4 py-2 rounded-lg font-mono text-xs uppercase tracking-widest flex items-center gap-2">
            <KeyRound className="w-4 h-4" /> Şifremi Değiştir
          </button>
          <button data-testid="add-user-btn" onClick={() => setDialog({ open: true, target: null })} className="btn-cyan px-4 py-2 rounded-lg font-mono text-xs uppercase tracking-widest flex items-center gap-2">
            <Plus className="w-4 h-4" /> Kullanıcı Ekle
          </button>
        </div>
      </div>

      <div className="glass-card hud-corners p-4">
        <div className="text-xs font-mono text-cyan-300/60 uppercase tracking-widest mb-3">{users.length} kullanıcı</div>
        <div className="space-y-1.5">
          {users.map((u) => (
            <div key={u.id} data-testid={`user-row-${u.email}`} className="flex items-center justify-between flex-wrap gap-2 p-2.5 rounded bg-slate-900/40 border border-cyan-500/10 hover:border-cyan-500/30 transition">
              <div>
                <div className="text-sm font-medium text-slate-100">{u.name} {u.id === me.id && <span className="text-[10px] text-cyan-400 font-mono">(SİZ)</span>}</div>
                <div className="text-[11px] font-mono text-slate-400">{u.email}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-mono uppercase border ${u.role === "admin" ? "bg-amber-500/15 text-amber-300 border-amber-500/30" : "bg-cyan-500/15 text-cyan-300 border-cyan-500/30"}`}>
                  {u.role === "admin" ? "İK Yöneticisi" : `${hotelName(u.hotel_code)} / ${deptName(u.department_code)}`}
                </span>
                <button data-testid={`edit-user-${u.email}`} onClick={() => setDialog({ open: true, target: u })} className="p-1.5 rounded border border-cyan-500/30 text-cyan-300 hover:bg-cyan-500/15"><Pencil className="w-3.5 h-3.5" /></button>
                {u.id !== me.id && (
                  <button data-testid={`delete-user-${u.email}`} onClick={() => remove(u)} className="p-1.5 rounded border border-rose-500/30 text-rose-300 hover:bg-rose-500/15"><Trash2 className="w-3.5 h-3.5" /></button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <UserDialog open={dialog.open} target={dialog.target} hotels={hotels}
        onClose={() => setDialog({ open: false, target: null })}
        onSaved={() => { setDialog({ open: false, target: null }); load(); }} />
      <ChangePasswordDialog open={pwOpen} onClose={() => setPwOpen(false)} />
    </div>
  );
}
